import * as Yup from 'yup'
import {isValidParam} from './Formatos';

Yup.addMethod(Yup.string, "valida_email", function (errorMessage) {
  return this.test(`valida_email`, errorMessage, function (email) {
    if (email && email.length > 0) {
      //var regex = /^[a-zA-ZñÑ0-9\+\.\_\%\-\+]{1,256}\@[a-zA-ZñÑ0-9][a-zA-ZñÑ0-9\-]{0,64}(\.[a-zA-Z0-9][a-zA-Z0-9\-]{1,25})+$/;
      var regex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
      if (regex.test(email)) {
        return true;
      } else {
        return false;
      }
    }

    return true;
  })
})
Yup.addMethod(Yup.string, "valida_rut_schv", function (errorMessage) {
  return this.test(`valida_rut_schv`, errorMessage, function (rut) {

    if (rut && rut.length > 0) {
      var regex = /^\d*$/;
      if (regex.test(rut)) {
        return true;
      } else {
        return false;
      }
    }

    return true;


  })
})
Yup.addMethod(Yup.string, "valida_patente_dcg", function (errorMessage) {
  return this.test(`valida_patente_dcg`, errorMessage, function (patente) {
    if (patente && patente.length > 0) {
      //var regex = /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}|[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}$/i;
      var regex = /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}|[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}|[a-zA-Z]{2,3}[0-9]{3}|[a-zA-Z]{3}[0-9]{2}[a-zA-Z]{1}$/i;
      if (regex.test(patente)) {
        return true;
      } else {
        return false;
      }
    }

    return true;
  })
})

let isFonoImplicado = false
export const validationSchemasDef = (pais, paisImplicado, isImplicado) => {
  
  let validationObject = {};

  if (isImplicado) {
    
    validationObject["rutImplicadoTercero"] = Yup.string().test(
      "len",
      "El RutIT no es válido 1.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length >= 0 && val.length <= 12);
      }
    ).valida_rut_schv("El RutIT no es válido 2.").required('Este campo es obligatorio.');
    validationObject["nombreInvolucradoTercero"] = Yup.string().required('Este campo es obligatorio.');
    
  }
  validationObject["tipoInvolucrado"] = Yup.string().required('Este campo es obligatorio.');
  validationObject["rutConductor"] = Yup.string().test(
      "len",
      "El RutC no es válido 1.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length >= 0 && val.length <= 12);
      }
    ).valida_rut_schv("El RutC no es válido 2.");
    validationObject["rutPropietario"] = Yup.string().test(
      "len",
      "El RutP no es válido 1.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length >= 0 && val.length <= 12);
      }
    ).valida_rut_schv("El RutP no es válido 2.");
    validationObject["rutDestinatario"] = Yup.string().test(
      "len",
      "El RutD no es válido 1.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length >= 0 && val.length <= 12);
      }
    ).valida_rut_schv("El RutD no es válido 2.");
    validationObject["emailImplicado"] = Yup.string().valida_email("Introduzca un Email válido");
    validationObject["emailConductor"] = Yup.string().valida_email("Introduzca un Email válido");
    validationObject["emailPropietario"] = Yup.string().valida_email("Introduzca un Email válido");
    validationObject["emailDestinatario"] = Yup.string().valida_email("Introduzca un Email válido");
    validationObject["patente"] = Yup.string().test(
      "len",
      "La Patente no es válida",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length >= 2 && val.length <= 7);
      }
    ).valida_patente_dcg("La Patente no es válida");
    validationObject["descripcion"] = Yup.string().test(
      "len",
      "No puede exceder 1000 caracteres.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length >= 0 && val.length <= 1000);
      }
    );
    validationObject["fonoImplicado"] = Yup.string().test(
      "len",
      "Teléfono debe ser de 10 dígitos.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length === 10);
      }
    );
    validationObject["movilImplicado"] = Yup.string().test(
      "len",
      "Movil debe ser de 10 dígitos.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length === 10);
      }
    );
    validationObject["fonoConductor"] = Yup.string().test(
      "len",
      "Teléfono debe ser de 10 dígitos.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length === 10);
      }
    );
    validationObject["movilConductor"] = Yup.string().test(
      "len",
      "Movil debe ser de 10 dígitos.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length === 10);
      }
    );
    validationObject["fonoPropietario"] = Yup.string().test(
      "len",
      "Teléfono debe ser de 10 dígitos.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length === 10);
      }
    );
    validationObject["movilPropietario"] = Yup.string().test(
      "len",
      "Movil debe ser de 10 dígitos.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length === 10);
      }
    );

  return Yup.object().shape(validationObject);
}
const validationSchemas2 = (pais, paisImplicado) => Yup.object({
  rutImplicadoTercero: Yup.string().test(
    "len",
    "El RutIT no es válido 1.",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length >= 0 && val.length <= 12);
    }
  ).valida_rut("El RutIT no es válido 2."),
  nombreInvolucradoTercero: Yup.string().required("Este campo es obligatorio."),
  tipoInvolucrado: Yup.string().required("Este campo es obligatorio."),
  rutImplicado: Yup.string().test(
    "len",
    "El RutI no es válido 1.",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length >= 0 && val.length <= 12);
    }
  ).valida_rut("El RutI no es válido 2."),
  rutConductor: Yup.string().test(
    "len",
    "El RutC no es válido 1.",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length >= 0 && val.length <= 12);
    }
  ).valida_rut("El RutC no es válido 2."),
  rutPropietario: Yup.string().test(
    "len",
    "El RutP no es válido 1.",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length >= 0 && val.length <= 12);
    }
  ).valida_rut("El RutP no es válido 2."),
  rutDestinatario: Yup.string().test(
    "len",
    "El RutD no es válido 1.",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length >= 0 && val.length <= 12);
    }
  ).valida_rut("El RuD no es válido 2."),
  emailImplicado: Yup.string().valida_email("Introduzca un Email válido"),
  emailConductor: Yup.string().valida_email("Introduzca un Email válido"),
  emailPropietario: Yup.string().valida_email("Introduzca un Email válido"),
  emailDestinatario: Yup.string().valida_email("Introduzca un Email válido"),
  patente: Yup.string().test(
    "len",
    "La Patente no es válida",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length >= 2 && val.length <= 7);
    }
  ).valida_patente_dcg("La Patente no es válida"),


  descripcion: Yup.string().test(
    "len",
    "No puede exeder 1000 caracteres..",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length >= 0 && val.length <= 1000);
    }
  ),
  fonoImplicado: Yup.string().test(
    "len",
    "El telefono debe ser de 9 dígitos..",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length === 9);
    }
  ),
  movilImplicado: Yup.string().test(
    "len",
    "El telefono debe ser de 9 dígitos..",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length === 9);
    }
  ),
  fonoConductor: Yup.string().test(
    "len",
    "El telefono debe ser de 9 dígitos..",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length === 9);
    }
  ),
  movilConductor: Yup.string().test(
    "len",
    "El telefono debe ser de 9 dígitos..",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length === 9);
    }
  ),
  fonoPropietario: Yup.string().test(
    "len",
    "El telefono debe ser de 9 dígitos..",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length === 9);
    }
  ),
  movilPropietario: Yup.string().test(
    "len",
    "El telefono debe ser de 9 dígitos..",
    (val) => {
      if (val === undefined) {
        return true;
      } if (paisImplicado !== '' || paisImplicado !== undefined) return true
      return val.length === 0 || (val.length === 9);
    }
  )
}
)
export default validationSchemasDef;